import { useI18n } from '@cascade/react/i18n';
import { getPendingTitleKey } from './SessionPending.helpers.ts';
import type { TSessionPendingProps } from './SessionPending.types.ts';
import { Layout } from '#layout/index.ts';

export const SessionPending = ({ status }: TSessionPendingProps) => {
  const { translate } = useI18n();
  const titleKey = getPendingTitleKey(status);

  return <Layout mode='card' title={translate(titleKey)} isLoading />;
};
